<form [formGroup]="serviceForm" (ngSubmit)="onSubmit()" #serviceFormRef="ngForm">
    <div class="modal-body">
        <!-- product inputs -->
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Nombre Servicio</label>
                <div class="col-9">
                    <input type="text" class="form-control" id="nombre" formControlName="nombre"
                        [attr.disabled]="detailMode?detailMode:null">
                    <div *ngIf="serviceFormRef.submitted &&( serviceForm.get('nombre').invalid ||  serviceForm.get('nombre').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="serviceForm.get('nombre').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Precio</label>
                <div class="col-9">
                    <input type="number" class="form-control" id="precio" formControlName="precio"
                        [attr.disabled]="detailMode?detailMode:null">
                    <div *ngIf="serviceFormRef.submitted &&( serviceForm.get('precio').invalid ||  serviceForm.get('precio').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="serviceForm.get('precio').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-3 label-control">Exento</label>
                <div class="col-9">
                    <input type="checkbox" class="input-checkbox" id="exento" formControlName="exento"
                        [attr.disabled]="detailMode?detailMode:null">
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" id="add-contact-item" class="btn btn-success add-contact-item" *ngIf="!detailMode">
            <i class="la la-paper-plane-o d-lg-none"></i>
            <span class="d-none d-lg-block">{{serviceToEdit?"Guardar":"Generar"}}</span>
        </button>
        <button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
            <span class="d-none d-lg-block">Cerrar</span>
        </button>
    </div>
</form>